(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calculator"] && !Shopify.designMode) return;
  try {
    
  // Prevent duplicate initialization
  if (window.calculatorInitialized) {
    console.log('Calculator already initialized');
  } else {
    window.calculatorInitialized = true;
    
    document.addEventListener('DOMContentLoaded', () => {
      const categories = [
        {
          "id": "prep",
          "title": "Paruošiamieji ir Projektavimo darbai",
          "items": [
            { "id": 1, "name": "Atvykimas į objektą miesto ribose + pirma valanda darbo", "unit": "vnt.", "price": 45.0 },
            { "id": 27, "name": "Elektros schemos sudarymas", "unit": "vartotojas", "price": 7.0 }
          ]
        },
        {
          "id": "cables",
          "title": "Kabelių tiesimas",
          "items": [
            { "id": 3, "name": "Atvykimas į objektą už miesto ribų", "unit": "Eur. / Km.", "price": 0.5 },
            { "id": 4, "name": "Kabelių tiesimas (iki 2,5 mm2)", "unit": "m.", "price": 1.5 },
            { "id": 5, "name": "Kabelių tiesimas (nuo 2,5 mm2 iki 10 mm2)", "unit": "m.", "price": 2.5 },
            { "id": 6, "name": "Kabelių tiesimas (nuo 16 mm2 iki 35 mm2)", "unit": "m.", "price": 4.0 },
            { "id": 14, "name": "Potinkinių dėžučių montavimas", "unit": "vnt.", "price": 3.0 }
          ]
        },
        {
          "id": "drilling",
          "title": "Gręžimas ir Vagų kirtimas",
          "items": [
            { "id": 7, "name": "Kabelio įvedimas į gofruotą / techninį vamzdį", "unit": "m.", "price": 0.5 },
            { "id": 8, "name": "Vagų kirtimas tinkuotose sienose", "unit": "m.", "price": 3.0 },
            { "id": 9, "name": "Vagų kirtimas mūro / blokelių sienose", "unit": "m.", "price": 4.0 },
            { "id": 10, "name": "Vagų kirtimas betono / monolito sienose", "unit": "m.", "price": 5.0 },
            { "id": 11, "name": "Skylių paruošimas elektros lizdams - gipso kartono sienoje", "unit": "vnt.", "price": 4.0 },
            { "id": 12, "name": "Skylių paruošimas elektros lizdams - mūro / blokelių sienoje", "unit": "vnt.", "price": 6.0 },
            { "id": 13, "name": "Skylių paruošimas elektros lizdams - betono / monolito sienose", "unit": "vnt.", "price": 17.0 },
            { "id": 15, "name": "Vagų užtaisymas (1 sluoksniu)", "unit": "m.", "price": 2.5 }
          ]
        },
        {
          "id": "shields",
          "title": "Skydų montavimas",
          "items": [
            { "id": 16, "name": "Kapitalinių sienų / perdangų gręžimas", "unit": "vnt.", "price": 7.0 },
            { "id": 17, "name": "Virstinkinio paskirstymo skydo montavimas", "unit": "vnt.", "price": 18.0 },
            { "id": 18, "name": "Potinkinio paskirstymo skydo 12 -24 mod. montavimas - gipso kartono / dujų silikatinių blokelių sienoje", "unit": "vnt.", "price": 40.0 },
            { "id": 19, "name": "Potinkinio paskirstymo skydo 36 - 42 mod. montavimas - gipso kartono / dujų silikatinių blokelių sienoje", "unit": "vnt.", "price": 50.0 },
            { "id": 20, "name": "Potinkinio paskirstymo skydo 12 -24 mod. montavimas - muro / blokelių sienoje", "unit": "vnt.", "price": 80.0 },
            { "id": 21, "name": "Potinkinio paskirstymo skydo 36 - 42 mod. montavimas - muro / blokelių sienoje", "unit": "vnt.", "price": 120.0 },
            { "id": 22, "name": "Potinkinio paskirstymo skydo 12 -24 mod. montavimas - betono / monolito sienoje", "unit": "vnt.", "price": 100.0 },
            { "id": 23, "name": "Potinkinio paskirstymo skydo 36 - 42 mod. montavimas - betono / monolito sienoje", "unit": "vnt.", "price": 150.0 },
            { "id": 24, "name": "Elektros skydo surinkimas", "unit": "modulis", "price": 5.0 }
          ]
        },
        {
          "id": "others",
          "title": "Kiti darbai",
          "items": [
            { "id": 25, "name": "Senos elektros instaliacijos demontavimas", "unit": "val.", "price": 30.0 },
            { "id": 26, "name": "Senos elektros instaliacijos tikrinimas / atsekimas", "unit": "val.", "price": 30.0 },
            { "id": 28, "name": "Laikino šviestuvo / išjungėjo / kištukinio lizdo prijungimas", "unit": "vnt.", "price": 5.0 },
            { "id": 29, "name": "Protingi atsakymai į kvailus klausimus", "unit": "val.", "price": 37.0 },
            { "id": 30, "name": "Kiti darbai:", "unit": "val.", "price": 30.0 }
          ]
        },
        {
          "id": "stage2",
          "title": "II etapo darbai",
          "items": [
            { "id": 101, "name": "Kištukinio lizdo / išjungėjo / perjungėjo montavimas", "unit": "vnt.", "price": 5.00 },
            { "id": 102, "name": "Dvigubo perjungėjo montavimas", "unit": "vnt.", "price": 7.00 },
            { "id": 103, "name": "Virstinkinio kištukinio lizdo montavimas", "unit": "vnt.", "price": 7.00 },
            { "id": 104, "name": "Virstinkinio išjungėjo montavimas", "unit": "vnt.", "price": 8.00 },
            { "id": 105, "name": "Sieninio (BRA) šviestuvo montavimas", "unit": "vnt.", "price": 15.00 },
            { "id": 106, "name": "Priglaistamo šviestuvo montavimas", "unit": "vnt.", "price": 7.00 },
            { "id": 107, "name": "Pakabinamo šviestuvo montavimas", "unit": "vnt.", "price": 20.00 },
            { "id": 108, "name": "Brangaus pakabinamo šviestuvo montavimas (10 proc. šviestuvo vertės)", "unit": "vnt.", "price": 100.00 },
            { "id": 109, "name": "LED profilio montavimas", "unit": "m.", "price": 10.00 },
            { "id": 110, "name": "LED juostos montavimas", "unit": "m.", "price": 10.00 },
            { "id": 111, "name": "Transformatoriaus / nuotolinio valdymo pulto instaliavimas", "unit": "vnt.", "price": 18.00 },
            { "id": 112, "name": "Hermetinio / lauko šviestuvo montavimas", "unit": "vnt.", "price": 18.00 },
            { "id": 113, "name": "Vienfazio įrenginio prijungimas prie vidaus elektros tinklo", "unit": "vnt.", "price": 18.00 },
            { "id": 114, "name": "Trifazio įrenginio prijungimas prie vidaus elektros tinklo", "unit": "vnt.", "price": 24.00 },
            { "id": 115, "name": "Termoreguliatoriaus prijungimas", "unit": "vnt.", "price": 12.00 },
            { "id": 116, "name": "Internetinio kištukinio lizdo prijungimas", "unit": "vnt.", "price": 6.00 },
            { "id": 117, "name": "Plastikinio lovelio montavimas", "unit": "m.", "price": 3.00 },
            { "id": 118, "name": "Skambučio / ventiliatoriaus montavimas", "unit": "vnt.", "price": 18.00 },
            { "id": 119, "name": "Rekuperatoriaus / kondicionieriaus ar pan. valdymo pulte prijungimas", "unit": "vnt.", "price": 15.00 },
            { "id": 120, "name": "Elektrinio šildytuvo (gyvatuko) montavimas", "unit": "vnt.", "price": 25.00 },
            { "id": 121, "name": "Rangovo akto parengimas ir perduodamas ESO", "unit": "vnt.", "price": 80.00 },
            { "id": 122, "name": "Kiti darbai (II etapas):", "unit": "val.", "price": 30.00 }
          ]
        }
      ];

      const calculatorList = document.getElementById('calculator-list');
      const totalPriceEl = document.getElementById('total-price');
      const resetBtn = document.getElementById('reset-btn');
      const estimateSection = document.getElementById('estimate-section');
      let quantities = {};
      let currentEstimate = null;

      function init() {
        renderCategories();
        setupEventListeners();
      }

      function renderCategories() {
        calculatorList.innerHTML = categories.map(category => `
          <div class="category-group" id="group-${category.id}">
            <div class="category-header" data-category-id="${category.id}">
              <div class="category-title">
                <span class="category-icon">📋</span>
                ${category.title}
              </div>
              <svg class="toggle-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            <div class="category-content">
              <div class="items-list">
                ${category.items.map(item => renderItem(item)).join('')}
              </div>
            </div>
          </div>
        `).join('');
        
        // Добавляем обработчики событий
        document.querySelectorAll('.category-header').forEach(header => {
          header.addEventListener('click', function() {
            const categoryId = this.getAttribute('data-category-id');
            toggleCategory(categoryId);
          });
        });
        
        document.querySelectorAll('.qty-btn').forEach(btn => {
          btn.addEventListener('click', function() {
            const id = parseInt(this.closest('.item-row').getAttribute('data-id'));
            const change = this.textContent === '-' ? -1 : 1;
            updateQuantity(id, change);
          });
        });
        
        document.querySelectorAll('.qty-input').forEach(input => {
          input.addEventListener('change', function() {
            const id = parseInt(this.closest('.item-row').getAttribute('data-id'));
            updateQuantityManual(id, this.value);
          });
        });
      }

      function renderItem(item) {
        const qty = quantities[item.id] || 0;
        const total = (qty * item.price).toLocaleString('lt-LT', { minimumFractionDigits: 2 });
        const hasValue = qty > 0;
        
        return `
          <div class="item-row" data-id="${item.id}" data-price="${item.price}">
            <div class="item-info">
              <div class="item-name">${item.name}</div>
              <div class="item-price-unit">${item.price.toLocaleString('lt-LT')} € / ${item.unit}</div>
            </div>
            <div class="item-controls">
              <div class="qty-control">
                <button class="qty-btn" type="button">-</button>
                <input type="number" class="qty-input" value="${qty}" min="0">
                <button class="qty-btn" type="button">+</button>
              </div>
              <div class="item-total ${hasValue ? 'has-value' : ''}" id="total-${item.id}">
                ${hasValue ? total + ' €' : ''}
              </div>
            </div>
          </div>
        `;
      }

      function toggleCategory(id) {
        const group = document.getElementById(`group-${id}`);
        if (group) group.classList.toggle('active');
      }

      function updateQuantity(id, change) {
        const currentQty = quantities[id] || 0;
        const newQty = Math.max(0, currentQty + change);
        quantities[id] = newQty;
        
        const input = document.querySelector(`.item-row[data-id="${id}"] .qty-input`);
        if (input) input.value = newQty;

        const itemEl = document.querySelector(`.item-row[data-id="${id}"]`);
        const price = parseFloat(itemEl.getAttribute('data-price'));
        const totalEl = document.getElementById(`total-${id}`);

        if (newQty > 0) {
          totalEl.textContent = (newQty * price).toLocaleString('lt-LT', { minimumFractionDigits: 2 }) + ' €';
          totalEl.classList.add('has-value');
          itemEl.style.background = 'rgba(14, 165, 233, 0.05)';
        } else {
          totalEl.textContent = '0.00 €';
          totalEl.classList.remove('has-value');
          itemEl.style.background = 'transparent';
        }
        calculateOverallTotal();
      }

      function updateQuantityManual(id, value) {
        const newQty = Math.max(0, parseInt(value) || 0);
        quantities[id] = newQty;
        
        const input = document.querySelector(`.item-row[data-id="${id}"] .qty-input`);
        if (input) input.value = newQty;

        const itemEl = document.querySelector(`.item-row[data-id="${id}"]`);
        const price = parseFloat(itemEl.getAttribute('data-price'));
        const totalEl = document.getElementById(`total-${id}`);

        if (newQty > 0) {
          totalEl.textContent = (newQty * price).toLocaleString('lt-LT', { minimumFractionDigits: 2 }) + ' €';
          totalEl.classList.add('has-value');
          itemEl.style.background = 'rgba(14, 165, 233, 0.05)';
        } else {
          totalEl.textContent = '0.00 €';
          totalEl.classList.remove('has-value');
          itemEl.style.background = 'transparent';
        }
        calculateOverallTotal();
      }

      function calculateOverallTotal() {
        let total = 0;
        categories.forEach(cat => cat.items.forEach(item => total += (quantities[item.id] || 0) * item.price));
        totalPriceEl.textContent = total.toLocaleString('lt-LT', { minimumFractionDigits: 2 }) + ' €';
        return total;
      }

      function setupEventListeners() {
        resetBtn.addEventListener('click', () => {
          quantities = {};
          renderCategories();
          calculateOverallTotal();
          // Скрываем смету при сбросе
          if (estimateSection) {
            estimateSection.classList.remove('visible');
            estimateSection.innerHTML = '';
          }
          currentEstimate = null;
        });

        const modal = document.getElementById('email-modal');
        const emailInput = document.getElementById('user-email');
        const modalSubmit = document.getElementById('modal-submit');
        const modalCancel = document.getElementById('modal-cancel');

        // Open Modal
        document.getElementById('estimate-btn').addEventListener('click', () => {
          const selected = getSelectedItems();
          if (selected.items.length === 0) {
            alert('Pasirinkite paslaugas!');
            return;
          }
          modal.style.display = 'flex';
          emailInput.focus();
        });

        // Close Modal
        modalCancel.addEventListener('click', () => {
          modal.style.display = 'none';
          emailInput.value = '';
          modalSubmit.disabled = false;
          modalSubmit.textContent = 'Siųsti ir Gauti';
        });

        // Close on outside click
        modal.addEventListener('click', (e) => {
          if (e.target === modal) {
            modal.style.display = 'none';
            emailInput.value = '';
            modalSubmit.disabled = false;
            modalSubmit.textContent = 'Siųsti ir Gauti';
          }
        });

        // Handle Submit - СОЗДАНИЕ СМЕТЫ НА СТРАНИЦЕ
        modalSubmit.addEventListener('click', async () => {
          const email = emailInput.value.trim();
          if (!email || !email.includes('@')) {
            alert('Įveskite teisingą el. pašto adresą!');
            return;
          }

          // Show loading state
          const originalText = modalSubmit.textContent;
          modalSubmit.textContent = 'Siunčiama...';
          modalSubmit.disabled = true;

          const { items, total } = getSelectedItems();
          
          // 1. Сохраняем данные сметы
          currentEstimate = {
            email: email,
            items: items,
            total: total,
            date: new Date().toLocaleDateString('lt-LT'),
            number: 'EST-' + Date.now().toString().slice(-6)
          };

          // 2. Создаем смету на странице
          createEstimateOnPage(currentEstimate);

          // 3. Автоматически скачиваем красивую HTML смету
          setTimeout(() => {
            downloadBeautifulEstimate(currentEstimate);
          }, 500);

          // 4. Отправляем данные ТОЛЬКО на info@nordicmaster.lt
          try {
            await sendDataToNordicMaster(email, items, total);
            
            showSuccessMessage('Sąmata sukurta ir išsiųsta!');
            
            // Закрываем модальное окно
            setTimeout(() => {
              modal.style.display = 'none';
              emailInput.value = '';
              modalSubmit.textContent = originalText;
              modalSubmit.disabled = false;
            }, 1500);
            
          } catch (error) {
            console.error('Error sending email:', error);
            showSuccessMessage('Sąmata sukurta ir atsisiųsta! Klaida siunčiant el. laišką.');
            
            // Закрываем модальное окно
            setTimeout(() => {
              modal.style.display = 'none';
              emailInput.value = '';
              modalSubmit.textContent = originalText;
              modalSubmit.disabled = false;
            }, 1500);
          }
        });

        function getSelectedItems() {
          const selected = [];
          let totalSum = 0;
          categories.forEach(cat => cat.items.forEach(item => {
            const qty = quantities[item.id] || 0;
            if (qty > 0) {
              const itemTotal = qty * item.price;
              selected.push({ ...item, qty, total: itemTotal });
              totalSum += itemTotal;
            }
          }));
          return { items: selected, total: totalSum };
        }

        function createEstimateOnPage(estimate) {
          if (!estimateSection) return;
          
          const rows = estimate.items.map(item => `
            <tr>
              <td>${item.name}</td>
              <td class="text-right">${item.price.toLocaleString('lt-LT', { minimumFractionDigits: 2 })} €</td>
              <td class="text-center">${item.qty} ${item.unit}</td>
              <td class="text-right">${item.total.toLocaleString('lt-LT', { minimumFractionDigits: 2 })} €</td>
            </tr>
          `).join('');

          estimateSection.innerHTML = `
            <div class="estimate-header">
              <div>
                <h2>SĄMATA</h2>
                <p>Elektros montavimo darbai</p>
              </div>
              <div class="estimate-meta">
                <p>Data: ${estimate.date}</p>
                <p>Numeris: ${estimate.number}</p>
              </div>
            </div>

            <div class="estimate-details">
              <div class="estimate-provider">
                <h3>Vykdytojas</h3>
                <p>Elektrikas</p>
                <p style="font-weight: 400; font-size: 14px; color: var(--text-secondary);">Kontaktai bus nurodyti po apžiūros</p>
              </div>
              <div class="estimate-client">
                <h3>Užsakovas</h3>
                <p>${estimate.email || '____________________'}</p>
              </div>
            </div>

            <table class="estimate-table">
              <thead>
                <tr>
                  <th>Paslauga / Darbas</th>
                  <th class="text-right">Kaina</th>
                  <th class="text-center">Kiekis</th>
                  <th class="text-right">Suma</th>
                </tr>
              </thead>
              <tbody>
                ${rows}
              </tbody>
            </table>

            <div class="estimate-totals">
              <div class="total-row">
                <span class="total-label">Suma (be PVM)</span>
                <span>${estimate.total.toLocaleString('lt-LT', { minimumFractionDigits: 2 })} €</span>
              </div>
              <div class="total-row grand-total">
                <span class="total-label" style="color: var(--accent-color)">VISO</span>
                <span>${estimate.total.toLocaleString('lt-LT', { minimumFractionDigits: 2 })} €</span>
              </div>
            </div>

            <div class="estimate-actions">
              <button class="estimate-btn-action estimate-btn-download" id="download-estimate-btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" 
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line x1="12" y1="15" x2="12" y2="3"></line>
                </svg>
                Atsisiųsti HTML Sąmatą
              </button>
              <button class="estimate-btn-action estimate-btn-print" onclick="window.print()">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" 
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="6 9 6 2 18 2 18 9"></polyline>
                  <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                  <rect x="6" y="14" width="12" height="8"></rect>
                </svg>
                Spausdinti
              </button>
            </div>

            <div class="estimate-footer">
              <p>* Ši sąmata yra preliminari. Galutinė kaina derinama objekte.</p>
              <p>* Kainos nurodytos be medžiagų savikainos, jei nesutarta kitaip.</p>
            </div>
          `;
          
          // Добавляем обработчик для кнопки скачивания
          setTimeout(() => {
            const downloadBtn = document.getElementById('download-estimate-btn');
            if (downloadBtn) {
              downloadBtn.addEventListener('click', () => {
                downloadBeautifulEstimate(estimate);
              });
            }
          }, 100);
          
          // Показываем смету
          estimateSection.classList.add('visible');
          
          // Прокручиваем к смете
          setTimeout(() => {
            estimateSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }

        function showSuccessMessage(message) {
          // Создаем или находим элемент для сообщения
          let successMsg = document.querySelector('.success-message');
          if (!successMsg) {
            successMsg = document.createElement('div');
            successMsg.className = 'success-message';
            estimateSection.insertBefore(successMsg, estimateSection.firstChild);
          }
          
          successMsg.textContent = message;
          successMsg.classList.add('visible');
          
          // Автоматически скрываем через 5 секунд
          setTimeout(() => {
            successMsg.classList.remove('visible');
          }, 5000);
        }

        // Функция для скачивания красивой HTML сметы
        function downloadBeautifulEstimate(estimate) {
          if (!estimate) return;
          
          const beautifulEstimateHTML = generateBeautifulEstimateHTML(
            estimate.items, 
            estimate.total, 
            estimate.email,
            estimate.date,
            estimate.number
          );
          
          // Создаем Blob и скачиваем файл
          const blob = new Blob([beautifulEstimateHTML], { type: 'text/html' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Sąmata_${estimate.number}_${estimate.date.replace(/\//g, '-')}.html`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }

        // ОТПРАВКА ТОЛЬКО НА info@nordicmaster.lt
        async function sendDataToNordicMaster(userEmail, items, total) {
          const message = `
🔥 **Nauja elektros darbų sąmata** 

📧 **Užsakovo el. paštas:** ${userEmail}
📅 **Data:** ${new Date().toLocaleDateString('lt-LT')}
🔢 **Sąmatos numeris:** EST-${Date.now().toString().slice(-6)}

📋 **Pasirinkti darbai:**
${items.map((i, index) => `${index + 1}. ${i.name}: ${i.qty} ${i.unit} × ${i.price} € = ${i.total.toFixed(2)} €`).join('\n')}

💰 **Bendra suma:** ${total.toFixed(2)} €
💰 **Su PVM (21%):** ${(total * 1.21).toFixed(2)} €

---
*Sąmata sukurta naudojant Elektros instaliacijos įrengimo kaičiuoklę*
*Visos kainos nurodytos EUR be PVM*
          `.trim();

          try {
            await fetch("https://formsubmit.co/ajax/info@nordicmaster.lt", {
              method: "POST",
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                _subject: `🔥 N. sąmata: ${userEmail} - ${total.toFixed(2)} €`,
                email: userEmail,
                message: message,
                samata_suma: total.toFixed(2) + " €",
                samata_suma_pvm: (total * 1.21).toFixed(2) + " €",
                samata_numeris: 'EST-' + Date.now().toString().slice(-6),
                samata_data: new Date().toLocaleDateString('lt-LT')
              })
            });
          } catch (e) {
            console.error("FormSubmit Error (info@nordicmaster.lt):", e);
            throw e;
          }
        }

        // ГЕНЕРАЦИЯ КРАСИВОЙ СМЕТЫ ДЛЯ СКАЧИВАНИЯ
        function generateBeautifulEstimateHTML(items, total, userEmail, date, number) {
          const rows = items.map(item => `
            <tr>
              <td class="item-name">${item.name}</td>
              <td class="text-right price">${item.price.toLocaleString('lt-LT', { minimumFractionDigits: 2 })} €</td>
              <td class="text-center quantity">${item.qty} ${item.unit}</td>
              <td class="text-right total">${item.total.toLocaleString('lt-LT', { minimumFractionDigits: 2 })} €</td>
            </tr>
          `).join('');

          return `<!DOCTYPE html>
<html lang="lt">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Sąmata ${number} - Elektros darbai</title>
    <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap" rel="stylesheet">
    <style>
        :root {
            --primary: #0ea5e9;
            --primary-dark: #0284c7;
            --secondary: #64748b;
            --success: #10b981;
            --light-bg: #f8fafc;
            --border: #e2e8f0;
            --text: #1e293b;
            --text-light: #64748b;
        }
        
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
        
        body {
            font-family: 'Inter', sans-serif;
            color: var(--text);
            line-height: 1.6;
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
            min-height: 100vh;
            padding: 40px 20px;
        }
        
        .invoice-container {
            max-width: 1000px;
            margin: 0 auto;
            background: white;
            border-radius: 24px;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
            overflow: hidden;
            position: relative;
        }
        
        /* Watermark */
        .watermark {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-45deg);
            font-size: 120px;
            font-weight: 800;
            color: rgba(14, 165, 233, 0.03);
            z-index: 1;
            white-space: nowrap;
            pointer-events: none;
        }
        
        .invoice-header {
            background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
            color: white;
            padding: 60px 50px 40px;
            position: relative;
            overflow: hidden;
        }
        
        .header-bg {
            position: absolute;
            top: 0;
            right: 0;
            width: 300px;
            height: 300px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 50%;
            transform: translate(30%, -30%);
        }
        
        .header-content {
            position: relative;
            z-index: 2;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
        }
        
        .company-info h1 {
            font-size: 42px;
            font-weight: 800;
            margin-bottom: 10px;
            letter-spacing: -1px;
        }
        
        .company-info p {
            font-size: 18px;
            opacity: 0.9;
            font-weight: 500;
        }
        
        .invoice-meta {
            text-align: right;
        }
        
        .invoice-meta .number {
            font-size: 32px;
            font-weight: 800;
            margin-bottom: 5px;
        }
        
        .invoice-meta .date {
            font-size: 16px;
            opacity: 0.9;
        }
        
        .invoice-body {
            padding: 50px;
            position: relative;
            z-index: 2;
        }
        
        .details-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 40px;
            margin-bottom: 50px;
        }
        
        .detail-card {
            background: var(--light-bg);
            padding: 30px;
            border-radius: 16px;
            border-left: 4px solid var(--primary);
        }
        
        .detail-card h3 {
            font-size: 14px;
            text-transform: uppercase;
            color: var(--secondary);
            margin-bottom: 15px;
            letter-spacing: 1px;
            font-weight: 600;
        }
        
        .detail-card p {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 5px;
        }
        
        .detail-card .note {
            font-size: 14px;
            color: var(--text-light);
            font-weight: 400;
            margin-top: 10px;
            font-style: italic;
        }
        
        .services-table {
            width: 100%;
            border-collapse: collapse;
            margin: 40px 0;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
            border-radius: 12px;
            overflow: hidden;
        }
        
        .services-table thead {
            background: linear-gradient(135deg, var(--light-bg) 0%, #e2e8f0 100%);
        }
        
        .services-table th {
            padding: 20px;
            text-align: left;
            font-size: 14px;
            text-transform: uppercase;
            color: var(--secondary);
            font-weight: 700;
            letter-spacing: 0.5px;
            border-bottom: 2px solid var(--border);
        }
        
        .services-table td {
            padding: 20px;
            border-bottom: 1px solid var(--border);
            font-size: 16px;
        }
        
        .services-table tbody tr:hover {
            background: rgba(14, 165, 233, 0.03);
        }
        
        .services-table .item-name {
            font-weight: 600;
            color: var(--text);
        }
        
        .services-table .price,
        .services-table .total {
            font-weight: 700;
            color: var(--primary);
        }
        
        .services-table .quantity {
            color: var(--text-light);
        }
        
        .totals-section {
            background: var(--light-bg);
            padding: 40px;
            border-radius: 16px;
            margin-top: 40px;
        }
        
        .total-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 0;
            border-bottom: 1px solid var(--border);
        }
        
        .total-row:last-child {
            border-bottom: none;
        }
        
        .total-row.grand-total {
            border-top: 2px solid var(--primary);
            margin-top: 10px;
            padding-top: 25px;
            font-size: 24px;
            font-weight: 800;
            color: var(--primary);
        }
        
        .total-label {
            font-size: 16px;
            color: var(--secondary);
            font-weight: 600;
        }
        
        .total-amount {
            font-weight: 700;
            font-size: 18px;
        }
        
        .grand-total .total-amount {
            font-size: 28px;
        }
        
        .invoice-footer {
            padding: 40px 50px;
            background: var(--light-bg);
            border-top: 1px solid var(--border);
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        
        .footer-notes {
            flex: 1;
        }
        
        .footer-notes p {
            font-size: 14px;
            color: var(--text-light);
            margin-bottom: 8px;
        }
        
        .footer-actions {
            display: flex;
            gap: 15px;
        }
        
        .print-btn {
            background: var(--primary);
            color: white;
            border: none;
            padding: 12px 24px;
            border-radius: 10px;
            font-weight: 600;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 8px;
            transition: all 0.2s;
            font-size: 15px;
        }
        
        .print-btn:hover {
            background: var(--primary-dark);
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(14, 165, 233, 0.3);
        }
        
        .badge {
            display: inline-block;
            padding: 6px 12px;
            background: var(--success);
            color: white;
            border-radius: 20px;
            font-size: 12px;
            font-weight: 600;
            margin-left: 10px;
        }
        
        .logo {
            font-size: 24px;
            font-weight: 800;
            color: white;
            margin-bottom: 20px;
            display: inline-block;
        }
        
        @media print {
            body {
                padding: 0;
                background: white;
            }
            
            .invoice-container {
                box-shadow: none;
                border-radius: 0;
            }
            
            .print-btn {
                display: none;
            }
            
            .watermark {
                opacity: 0.1;
            }
        }
        
        @media (max-width: 768px) {
            body {
                padding: 20px 10px;
            }
            
            .invoice-header {
                padding: 40px 20px 30px;
            }
            
            .header-content {
                flex-direction: column;
                gap: 20px;
            }
            
            .company-info h1 {
                font-size: 32px;
            }
            
            .invoice-meta {
                text-align: left;
            }
            
            .invoice-body {
                padding: 30px 20px;
            }
            
            .details-grid {
                grid-template-columns: 1fr;
                gap: 20px;
            }
            
            .services-table th,
            .services-table td {
                padding: 12px 8px;
                font-size: 14px;
            }
            
            .invoice-footer {
                flex-direction: column;
                gap: 20px;
                padding: 30px 20px;
            }
            
            .footer-actions {
                width: 100%;
            }
            
            .print-btn {
                flex: 1;
                justify-content: center;
            }
        }
    </style>
</head>
<body>
    <div class="invoice-container">
        <div class="watermark">SĄMATA</div>
        
        <header class="invoice-header">
            <div class="header-bg"></div>
            <div class="header-content">
                <div class="company-info">
                    <div class="logo">⚡ Elektros Darbai</div>
                    <h1>ELEKTROS DARBŲ SĄMATA</h1>
                    <p>Profesionalus elektros montavimo darbai</p>
                </div>
                <div class="invoice-meta">
                    <div class="number">${number}</div>
                    <div class="date">Data: ${date}</div>
                    <div class="badge">PRELIMINARI</div>
                </div>
            </div>
        </header>
        
        <div class="invoice-body">
            <div class="details-grid">
                <div class="detail-card">
                    <h3>Paslaugų Teikėjas</h3>
                    <p>⚡ “Šiaurės Meistrai” MB</p>
                    <p>📞  0 606 40202</p>
                    <p>📧 info@nordicmaster.lt</p>
                    <p class="note">Šilumos siurbliai | oro kondicionieriai | elektros instaliacija | rekuperatoriai</p>
                </div>
                
                <div class="detail-card">
                    <h3>Užsakovas</h3>
                    <p>${userEmail || 'Nurodyti kontaktai'}</p>
                    <p class="note">* Sąmata sukurta pagal pasirinktas paslaugas</p>
                </div>
            </div>
            
            <table class="services-table">
                <thead>
                    <tr>
                        <th>Paslauga / Darbas</th>
                        <th class="text-right">Kaina (€/vnt)</th>
                        <th class="text-center">Kiekis</th>
                        <th class="text-right">Suma (€)</th>
                    </tr>
                </thead>
                <tbody>
                    ${rows}
                </tbody>
            </table>
            
            <div class="totals-section">
                <div class="total-row">
                    <span class="total-label">Suma (be PVM):</span>
                    <span class="total-amount">${total.toLocaleString('lt-LT', { minimumFractionDigits: 2 })} €</span>
                </div>
                <div class="total-row">
                    <span class="total-label">PVM (21%):</span>
                    <span class="total-amount">${(total * 0.21).toLocaleString('lt-LT', { minimumFractionDigits: 2 })} €</span>
                </div>
                <div class="total-row grand-total">
                    <span class="total-label">VISAS SANAUDAS:</span>
                    <span class="total-amount">${(total * 1.21).toLocaleString('lt-LT', { minimumFractionDigits: 2 })} €</span>
                </div>
            </div>
        </div>
        
        <footer class="invoice-footer">
            <div class="footer-notes">
                <p>⚠️ <strong>Svarbu:</strong> Ši sąmata yra preliminari. Galutinė kaina gali skirtis priklausomai nuo objekto sąlygų.</p>
                <p>📝 <strong>Pastaba:</strong> Kainos nurodytos be medžiagų savikainos. Medžiagų kaina apskaičiuojama atskirai.</p>
                <p>📅 <strong>Terminas:</strong> Darbų pradžia susitariama individualiai po objekto apžiūros.</p>
            </div>
            
            <div class="footer-actions">
                <button class="print-btn" onclick="window.print()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="6 9 6 2 18 2 18 9"></polyline>
                        <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                        <rect x="6" y="14" width="12" height="8"></rect>
                    </svg>
                    Spausdinti
                </button>
            </div>
        </footer>
    </div>
    
    <script>
        // Автоматическая печать при загрузке (опционально)
        // window.addEventListener('load', () => {
        //     setTimeout(() => {
        //         window.print();
        //     }, 1000);
        // });
    </script>
</body>
</html>`;
        }

        // Search functionality
        document.getElementById('service-search').addEventListener('input', function (e) {
          const term = e.target.value.toLowerCase();
          document.querySelectorAll('.item-row').forEach(row => {
            const matches = row.querySelector('.item-name').textContent.toLowerCase().includes(term);
            row.style.display = matches ? 'flex' : 'none';
          });
          document.querySelectorAll('.category-group').forEach(group => {
            const hasVisible = Array.from(group.querySelectorAll('.item-row')).some(r => r.style.display !== 'none');
            group.style.display = hasVisible ? 'block' : 'none';
            if (term.length > 1 && hasVisible) group.classList.add('active');
          });
        });
      }

      init();
      setTimeout(() => {
        const firstCategory = document.querySelector('.category-group');
        if (firstCategory) firstCategory.classList.add('active');
      }, 300);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
